import RegisterCorporate from "app/pages/corporate/components/RegisterCorporate";
import CorporateLayout from "app/pages/corporate/layout/CorporateLayout";
import { RequirementDetails } from "app/pages/corporate/requirement-details";
import { RequirementListing } from "app/pages/corporate/requirement-listing";
import RequirementBasic from "app/pages/corporate/requirement-post/RequirementBasic";
import RequirementAdvanced from "app/pages/corporate/requirement-post/RequirementAdvanced";
import Settings from "app/pages/corporate/settings/Settings";
import { VerifyOTP } from "app/pages/module/auth/VerifyOTP";
import { RequirementReview } from "app/pages/corporate/requirement-post/RequirementReview";
import BiddingListing from "app/pages/corporate/bidding-listing";
import BiddingDetails from "app/pages/corporate/bidding-details";

export const CorporateRoutes = [
  { path: "/corporate/register", element: RegisterCorporate },
  { path: "/verify-otp", element: VerifyOTP },
  {
    path: "/corporate",
    element: CorporateLayout,
    children: [
      { path: "requirement-listing", element: RequirementListing },
      { path: "requirement-listing/:id", element: RequirementDetails },

      { path: "requirement-post/basic", element: RequirementBasic },
      { path: "requirement-post/advanced/:reqId", element: RequirementAdvanced },
      { path: "requirement-post/review/:reqId", element: RequirementReview },

      { path: "settings", element: Settings },
      
      { path: "biddings", element: BiddingListing },
      { path: "biddings/:id", element: BiddingDetails },
    ],
  },
];
